import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconAperture = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--aperture")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
          <path d="M12 1a11.125 11.125 0 0 1 1.31.078 11.008 11.008 0 0 1 8.792 6.56C22.68 8.974 23 10.45 23 12c0 2.418-.78 4.654-2.102 6.47a.894.894 0 0 1-.098.131 10.985 10.985 0 0 1-9.974 4.337.894.894 0 0 1-.136-.016 11.008 11.008 0 0 1-8.802-6.586A10.96 10.96 0 0 1 1 12c0-2.418.78-4.654 2.102-6.47A.894.894 0 0 1 3.2 5.4 10.985 10.985 0 0 1 12 1zm4.619 12.999-4.03 6.982a8.98 8.98 0 0 0 6.253-3.134l-2.223-3.848zM12.577 17l-8.06.001a9.005 9.005 0 0 0 5.838 3.849L12.577 17zm7.911-8h-4.446l4.031 6.982c.594-1.2.927-2.552.927-3.982 0-1.052-.18-2.061-.512-3zM15.465 12 13.733 9h-3.467l-1.732 2.999L10.267 15h3.465l1.733-3.001zM3 12c0 1.052.18 2.062.512 3h4.446L3.927 8.018A8.963 8.963 0 0 0 3 12zm2.158-5.847L7.38 10l4.031-6.981a8.98 8.98 0 0 0-6.253 3.134zm8.487-3.003L11.42 7h8.063a9.005 9.005 0 0 0-5.84-3.85z" id="icon--centivo--aperture"/>
      </defs>
      <g fill="none" fillRule="evenodd">
          <use fill="currentColor" xlinkHref="#icon--centivo--aperture"/>
      </g>
  </IconWrapper>
)
